import axios from "axios";
import { createMessage, createGenericErrorAlert } from "./messages";
import { tokenConfig, tokenConfigUpload } from "./auth";

import { 
    GET_INCOMING_INVOICES, 
    GET_INVOICES, 
    GET_OUTGOING_INVOICES, 
    GET_INVOICE_DROPS, 
    GET_INVOICE, 
    GET_INVOICE_WITHOUT_ATTACHMENTS, 
    CLEAR_INVOICE_ATTACHMENTS, 
    CLEAR_INVOICES, 
    CLEAR_INVOICE, 
    DELETE_INVOICE, 
    TOGGLE_INVOICE_TAB, 
    SEND_NEW_INVOICE,
    SAVE_NEW_INVOICE_DRAFT,
    SEND_EX_INVOICE,
    SAVE_EX_INVOICE_DRAFT,
    RESPOND_TO_INVOICE, 
    START_INVOICE_REVISION, 
    GET_INVOICE_HISTORY,
    GET_INVOICE_VERSIONS,
    GET_INVOICE_VERSION_DETAIL,
    CLEAR_INVOICE_VERSION_DETAIL,
    SET_INVOICE_DROP,
    GET_INVOICES_INCLUDING_HIDDEN
} from "./types";

// GET ALL INVOICES
// *** REPLACE THIS WITH ONE NEW CALL: GET-INVOICE-LIST --------------------
export const getInvoicesPartTwo = (incomingList) => (dispatch, getState) => {
    axios
        .get(`/v0/api/invoice/get-invoice-outgoing-list`, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                const outgoingList = res.data.map(invoice => {
                    return (
                        {...invoice, incoming: false}
                    )
                })
                const combinedInvoiceList = [...outgoingList, ...incomingList];
                const invoiceDrops = combinedInvoiceList.map(invoice => {
                    return {
                        invoice_id: invoice.invoice_id,
                        invoice_number: invoice.invoice_number,
                        contract_id: invoice.contract_id,
                        contract_name: invoice.contract_name,
                        project_id: invoice.project_id,
                        project_name: invoice.project_name
                    }
                })
                dispatch({
                    type: GET_INVOICES,
                    payload: {invoices: combinedInvoiceList, invoiceDrops: invoiceDrops},
                });
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};
export const getInvoices = () => (dispatch, getState) => {
    axios
        .get(`/v0/api/invoice/get-invoice-incoming-list`, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                const incomingList = res.data.map(invoice => {
                    return (
                        {...invoice, incoming: true}
                    )
                })
                dispatch(getInvoicesPartTwo(incomingList));
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};
// *** ------------------------------------------------------------------------------------


// GET ALL INVOICES
// *** REPLACE THIS WITH ONE NEW CALL: GET-INVOICE-LIST --------------------
export const getInvoicesIncludingHiddenPartTwo = (incomingList) => (dispatch, getState) => {
    axios
        .get(`/v0/api/invoice/get-invoice-outgoing-list`, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                const combinedInvoiceList = [...res.data, ...incomingList];
                const invoiceDrops = combinedInvoiceList.map(invoice => {
                    return {
                        invoice_id: invoice.invoice_id,
                        invoice_number: invoice.invoice_number,
                        contract_id: invoice.contract_id,
                        contract_name: invoice.contract_name,
                        project_id: invoice.project_id,
                        project_name: invoice.project_name
                    }
                })
                dispatch({
                    type: GET_INVOICES_INCLUDING_HIDDEN,
                    payload: {invoices: combinedInvoiceList, invoiceDrops: invoiceDrops},
                });
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};
export const getInvoicesIncludingHidden = () => (dispatch, getState) => {
    // *** REPLACE WITH CALL THAT RETURNS invoices OF HIDDEN PROJECTS INCLUDED
    axios
        .get(`/v0/api/invoice/get-invoice-incoming-list`, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                dispatch(getInvoicesIncludingHiddenPartTwo(res.data));
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};
// *** ------------------------------------------------------------------------------------

// SET INVOICE DROP
export const setInvoiceDrop = (invoiceDrop) => (dispatch, getState) => {
    dispatch({
        type: SET_INVOICE_DROP,
        payload: invoiceDrop
    });
};


// GET ALL INCOMING INVOICES
export const getIncomingInvoices = () => (dispatch, getState) => {
    axios
        .get(`/v0/api/invoice/get-invoice-incoming-list`, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                dispatch({
                    type: GET_INCOMING_INVOICES,
                    payload: res.data,
                });
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};
// GET ALL OUTGOING INVOICES
export const getOutgoingInvoices = () => (dispatch, getState) => {
    axios
        .get(`/v0/api/invoice/get-invoice-outgoing-list`, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                dispatch({
                    type: GET_OUTGOING_INVOICES,
                    payload: res.data,
                });
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};


// GET INVOICE INFORMATION
export const getInvoice = (id) => (dispatch, getState) => {
    axios
        .get(`/v0/api/invoice/${id}/`, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                const invoice = res.data;
                const invoiceDrop = {
                    invoice_id: res.data.invoice_id,
                    invoice_number: res.data.invoice_number,
                    contract_id: res.data.contract_id,
                    contract_name: res.data.contract_name,
                    project_id: res.data.project_id,
                    project_name: res.data.project_name
                }
                dispatch({
                    type: GET_INVOICE,
                    payload: {invoice, invoiceDrop},
                });
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};
// GET INVOICE INFORMATION WITHOUT ATTACHMENTS (FOR INVOICE REVISIONS)
export const getInvoiceWithoutAttachments = (id) => (dispatch, getState) => {
    axios
        .get(`/v0/api/invoice/${id}/`, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                const invoice = res.data;
                const invoiceDrop = {
                    invoice_id: res.data.invoice_id,
                    invoice_number: res.data.invoice_number,
                    contract_id: res.data.contract_id,
                    contract_name: res.data.contract_name,
                    project_id: res.data.project_id,
                    project_name: res.data.project_name
                }
                dispatch({
                    type: GET_INVOICE_WITHOUT_ATTACHMENTS,
                    payload: {invoice, invoiceDrop},
                });
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};
// CLEAR INVOICE ATTACHMENTS
export const clearInvoiceAttachments = () => (dispatch) => {
    dispatch({
        type: CLEAR_INVOICE_ATTACHMENTS,
        payload: null,
    });
};
// GET INVOICE HISTORY
export const getInvoiceHistory = (id) => (dispatch, getState) => {
    axios
        .get(`/v0/api/invoice/get-invoice-history/${id}`, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                dispatch({
                    type: GET_INVOICE_HISTORY,
                    payload: res.data,
                });
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};
// GET LIST OF PAST (SUPERSEDED) INVOICE VERSIONS
export const getInvoiceVersions = (id) => (dispatch, getState) => {
    axios
        .get(`/v0/api/invoice/get-invoice-versions/${id}`, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                dispatch({
                    type: GET_INVOICE_VERSIONS,
                    payload: res.data,
                });
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};
// GET FULL DETAIL FOR ONE PAST INVOICE VERSION (reuses the same detail endpoint as the live invoice)
export const getInvoiceVersionDetail = (id) => (dispatch, getState) => {
    axios
        .get(`/v0/api/invoice/${id}/`, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                dispatch({
                    type: GET_INVOICE_VERSION_DETAIL,
                    payload: res.data,
                });
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};
// CLEAR PAST VERSION DETAIL (on modal close)
export const clearInvoiceVersionDetail = () => (dispatch) => {
    dispatch({
        type: CLEAR_INVOICE_VERSION_DETAIL,
        payload: null,
    });
};
// CLEAR INVOICES
export const clearInvoices = () => (dispatch) => {
    dispatch({
        type: CLEAR_INVOICES,
        payload: null
    });
};
// CLEAR INVOICE
export const clearInvoice = () => (dispatch) => {
    dispatch({
        type: CLEAR_INVOICE,
        payload: null
    });
};
// DELETE INVOICE
export const deleteInvoice = (id, number) => (dispatch, getState) => {
    axios
        .delete(`/v0/api/invoice/${id}`, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                dispatch({
                    type: DELETE_INVOICE,
                    payload: id,
                });
                if (number != null) {
                    dispatch(createMessage({ success: `Invoice draft ${number} deleted` }));
                } else {
                    dispatch(createMessage({ success: `Invoice draft deleted` }));
                }
            }
        })
        .catch((err) => console.log(err));
};
// TOGGLE INVOICE TAB
export const toggleInvoiceTab = () => (dispatch) => {
    dispatch({
        type: TOGGLE_INVOICE_TAB,
        payload: null
    });
}
// CREATE AND SEND INVOICE - BACKUP
export const sendNewInvoice = (formData, purchaser) => (dispatch, getState) => {
    return axios
        .post(`/v0/api/invoice/`, formData, tokenConfigUpload(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                const newInvoiceDrop = {
                    invoice_id: res.data.invoice_id, 
                    invoice_number: res.data.invoice_number, 
                    contract_id: res.data.contract_id, 
                    contract_name: res.data.contract_name, 
                    project_id: res.data.project_id, 
                    project_name: res.data.project_name
                };
                const newInvoice = res.data;
                dispatch({
                    type: SEND_NEW_INVOICE,
                    payload: {newInvoice, newInvoiceDrop},
                });
                dispatch(createMessage({ success: `Invoice Sent to ${purchaser}.` }));
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err})));
};
// CREATE INVOICE AS DRAFT
export const createInvoiceDraft = (invoice) => (dispatch, getState) => {
    return axios
        .post(`/v0/api/invoice/`, invoice, tokenConfigUpload(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                const newInvoiceDrop = {
                    invoice_id: res.data.invoice_id, 
                    invoice_number: res.data.invoice_number, 
                    contract_id: res.data.contract_id, 
                    contract_name: res.data.contract_name, 
                    project_id: res.data.project_id, 
                    project_name: res.data.project_name
                };
                const newInvoice = res.data;
                dispatch({
                    type: SAVE_NEW_INVOICE_DRAFT,
                    payload: {newInvoice, newInvoiceDrop},
                });
                dispatch(createMessage({ success: "Invoice Draft Saved" }));
            }     
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};

// SEND INVOICE (PREVIOUSLY SAVED AS DRAFT)
export const sendSavedInvoice = (id, invoice, purchaser) => (dispatch, getState) => {
    return axios
        .put(`/v0/api/invoice/${id}/`, invoice, tokenConfigUpload(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                const newInvoiceDrop = {
                    invoice_id: res.data.invoice_id, 
                    invoice_number: res.data.invoice_number, 
                    contract_id: res.data.contract_id, 
                    contract_name: res.data.contract_name, 
                    project_id: res.data.project_id, 
                    project_name: res.data.project_name
                };
                const newInvoice = res.data;
                dispatch({
                    type: SEND_EX_INVOICE,
                    payload: {newInvoice, newInvoiceDrop},
                });
            }
            dispatch(createMessage({ success: `Invoice Sent to ${purchaser}.` }));
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};
// SAVE EDITS TO INVOICE DRAFT (PREVIOUSLY SAVED)
export const editInvoiceDraft = (id, invoice) => (dispatch, getState) => {
    return axios
        .put(`/v0/api/invoice/${id}/`, invoice, tokenConfigUpload(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                const newInvoiceDrop = {
                    invoice_id: res.data.invoice_id, 
                    invoice_number: res.data.invoice_number, 
                    contract_id: res.data.contract_id, 
                    contract_name: res.data.contract_name, 
                    project_id: res.data.project_id, 
                    project_name: res.data.project_name
                };
                const newInvoice = res.data;
                dispatch({
                    type: SAVE_EX_INVOICE_DRAFT,
                    payload: {newInvoice, newInvoiceDrop},
                });
                dispatch(createMessage({ success: "Invoice Draft Saved." }));
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};
// SAVE EDITS TO INVOICE DRAFT (PREVIOUSLY SAVED)
export const respondToInvoice = (id, updates, alert) => (dispatch, getState) => {
    return axios
        .put(`/v0/api/invoice/${id}/`, updates, tokenConfigUpload(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                dispatch({
                    type: RESPOND_TO_INVOICE,
                    payload: res.data,
                });
                dispatch(createMessage({ success: alert }));
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};